import moment from "moment/moment";
import {KeyConstant} from "../constant/keyConstant";
import {ObjectCommon} from "../mapperModel/ObjectCommon"
import {DefaultValue} from "../constant/DefaultValue";

export const mapObject = (type , startDate , endDate)=>{

    if (!!startDate){
        startDate = moment(startDate).toDate()
    }else {
        startDate = DefaultValue.startDate
    }
    if (!!endDate){
        endDate = moment(endDate).toDate()
    }else {
        endDate = DefaultValue.endDate
    }
    if (!type){
        type = KeyConstant.THIRTY_DAYS_AGO
    }

    return new ObjectCommon(type, startDate, endDate)
}
